module.exports = __webpack_public_path__ + "static/media/banksy-fugl-crop.424cf223.png";